import request from '@/utils/request.js'

export function getSupplierListPage(data){
    return request({
        url: 'sim/supplier/listPage',
        method: 'post',
        data
    })
}

export function addAccount(data){
    return request({
        url: 'sim/supplier/add',
        method: 'post',
        data
    })
}

export function editAccount(data){
    return request({
        url: 'sim/supplier/update',
        method: 'post',
        data
    })
}

export function getAccountInfo(data){
    return request({
        url: 'sim/supplier/detail',
        method: 'post',
        data
    })
}

export function changeAccountState(data){
    return request({
        url: 'sim/supplier/state',
        method: 'post',
        data
    })
}
export function getAGentAuthList(data){
    return request({
        url: 'authNickname/agent/list',
        method: 'post',
        data
    })
}

export function getBranchSupplierList(data){
    return request({
        url: 'sim/supplier/list',
        method: 'post',
        data
    })
}
export function agentVerified(data){
    return request({
        url: 'authNickname/agent/auth',
        method: 'post',
        data
    })
}
export function subAuth(data){
    return request({
        url: 'authNickname/agent/auth/count',
        method: 'post',
        data
    })
}


/***平台获取公告列表***/
export function getNotifyListPage(data){
    return request({
        url: 'notice/list',
        method: 'post',
        data
    })
}
/***平台发布公告***/
export function publishNotify(data){
    return request({
        url: 'notice/add',
        method: 'post',
        data
    })
}
/***平台删除公告***/
export function deleteNotify(data){
    return request({
        url: 'notice/delete',
        method: 'post',
        data
    })
}
/***代理商获取公告列表***/
export function getAgentNotifyListPage(data){
    return request({
        url: 'agentNotice/list',
        method: 'post',
        data
    })
}
/***代理商删除公告***/
export function agentDeleteNotify(data){
    return request({
        url: 'agentNotice/delete',
        method: 'post',
        data
    })
}
/***登录显示公告***/
export function agentHomeNotify(data){
    return request({
        url: 'agentNotice/new/notice',
        method: 'post',
        data
    })
}
/***登录显示公告标记为已读***/
export function agentHomeNotifyReaded(data){
    return request({
        url: 'agentNotice/udapte',
        method: 'post',
        data
    })
}

export function getFeedbackListPage(data){
    return request({
        url: 'userProblem/list',
        method: 'post',
        data
    })
}
export function deleteFeedback(data){
    return request({
        url: 'userProblem/delete',
        method: 'post',
        data
    })
}
export function replayFeedback(data){
    return request({
        url: 'userProblem/replay',
        method: 'post',
        data
    })
}
export function exportFeedback(data){
    return request({
        url: 'problemOrOrder/readExcels',
        method: 'get',
        data
    })
}
/***获取实名认证列表*****/
export function getUsersAuthList(data){
    return request({
        url: 'authNickname/list',
        method: 'post',
        data
    })
}

/***实名认证审核*****/
export function userVerified(data){
    return request({
        url: 'authNickname/auth',
        method: 'post',
        data
    })
}

/***（管理员）获取投诉信息列表*****/
export function getComplaintsList(data){
    return request({
        url: 'userProblem/agent/complainat/list',
        method: 'post',
        data
    })
}

/***（代理商）获取投诉信息列表*****/
export function getAgentComplaintsList(data){
    return request({
        url: 'userProblem/my/complainat/list',
        method: 'post',
        data
    })
}

/***（代理商）上传投诉信息*****/
export function doComplaint(data){
    return request({
        url: 'userProblem/insert/complainat',
        method: 'post',
        data
    })
}

/***（管理员）回复投诉信息*****/
export function doDisposeComplaint(data){
    return request({
        url: 'userProblem/reply/complainat',
        method: 'post',
        data
    })
}


/*** 微信推送信息列表 *****/
export function getWeChatPushList(data){
    return request({
        url: 'wx/msg/list',
        method: 'post',
        data
    })
}

/*** 微信推送操作 *****/
export function doWeChatPush(data){
    return request({
        url: 'wx/msg/insert',
        method: 'post',
        data
    })
}

/*** 微信推送时获取供应商列表 *****/
export function getWeChatPushSupplierList(data){
    return request({
        url: 'wx/msg/supplier/list',
        method: 'post',
        data
    })
}

/** sim卡转入历史卡片 */
export function changeSimIntoHistory(param){
    return request({
        url: 'sim/supplier/changeIntoHistory/'+param,
        method: 'get'
    })
}


/** 查询我的提现设置 */
export function getAgentWithdrawConfig(data){
    return request({
        url: 'agent/collectConfig/cashout/select',
        method: 'post',
        data,
    })
}


/** 修改我的提现设置 */
export function saveAgentWithdrawConfig(data){
    return request({
        url: 'agent/collectConfig/cashout/add',
        method: 'post',
        data,
    })
}
